import * as React from 'react';
import { DestinationOptions } from 'blocks/AutomationWorkflowWizard/containers/AutomationWorkflowWizard/types';
import ToggleCard from 'components/ToggleCard';
import {
  AutomationOptionsCardsOptions,
  AutopostingOptionsMetadata,
  DestinationStepView,
} from './types';
import { block } from './utils';

interface AutomationOptionsCardsProps<
  TOption extends AutomationOptionsCardsOptions
> {
  metadata: AutopostingOptionsMetadata;
  options: TOption[];
  value: TOption['value'][keyof TOption['value']];
  currentStep: DestinationStepView;
  onChange: (props: DestinationOptions) => void;
}

const AutomationOptionsCards = <TOptions extends AutomationOptionsCardsOptions>(
  props: AutomationOptionsCardsProps<TOptions>,
) => {
  const { metadata, options, value, currentStep, onChange } = props;

  const handleSetNewCheckedValue = (
    option: AutomationOptionsCardsOptions,
  ): void => {
    const { value: optionValue, isPro, onUpgrade } = option;

    if (isPro) {
      return onUpgrade?.();
    }

    return onChange({
      ...optionValue,
      stepView: currentStep,
    });
  };

  return (
    <div className={block({ [metadata.layout]: true })}>
      {options.map(option => {
        const { id, contents, icon, isPro, value: optionValue, size } = option;

        return (
          <ToggleCard
            className={block('toggle-card')}
            {...{ icon, isPro }}
            key={id}
            hasAccess={isPro}
            info={contents}
            theme="blue"
            checked={Object.values(optionValue).includes(value)}
            onChange={() => handleSetNewCheckedValue(option)}
            size={size}
          />
        );
      })}
    </div>
  );
};

export default AutomationOptionsCards;
